import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "common/locales";
import { FileEntry } from "model";
import { useState } from "react";
import styled from "styled-components";
import FileEntryList from "./FileEntryList";

export default function ClosableList({
  fileEntries,
  title,
}: {
  fileEntries: Array<FileEntry>;
  title: string;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <ListItem key="arable" button onClick={toggleOpen}>
        <ListItemText primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <FileEntryList fileEntries={fileEntries} />
      </Collapse>
    </>
  );

  function toggleOpen() {
    setOpen(!open);
  }
}

const Nested = styled(Collapse)(
  ({ theme }) => `
    padding-left: ${theme.spacing(4)};
  `
);
